<template>
    <v-card>
        <v-card-title>
            {{$t('event.merchant')}}
            <v-spacer></v-spacer>
            <v-btn class="mr-3" :disabled="!selectedMerchants.length" :dark="!!selectedMerchants.length" color="red" @click="deleteMerchant">
                Delete Selected ({{selectedMerchants.length}})
            </v-btn>
            <v-btn color="primary" @click="$router.push({name: 'merchant-batch-add'})">
                {{$t('merchant.add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col class="pt-0">
                    <v-text-field v-model="search"
                                  append-icon="mdi-magnify"
                                  :label="$t('search')"
                                  single-line
                                  hide-details
                                  clearable>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-data-table :headers="headers"
                          :items="eventMerchants"
                          :loading="isEventMerchantPending"
                          :search="search"
                          show-select
                          v-model="selectedMerchants"
                          no-data-text="No Merchants">
                <template v-slot:item.createdAt="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="primary"
                    :to="{name: 'event-merchants-edit', params: {merchantId: item.id}}">
                        {{$t('edit')}}
                        <v-icon right>mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
        
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <v-dialog v-model="dialog" scrollable max-width="640px">
            <v-card>
                <v-card-text style="height: 360px; padding: 15px" v-html="dialogMsg">
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <RouterView></RouterView>
    </v-card>
</template>

<script>
    import {computed, ref} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";

    export default {
        name: 'EventMerchantList',
        setup(props, {root}) {
            const {Merchant} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);
            
            const overlay = ref(false);
            const dialog = ref(false);
            const dialogMsg = ref('');
            const selectedMerchants = ref([]);
            
            const merchantParams = computed(() => {
                let params = {
                    query: {
                        eventId: eventId.value,
                        $sort: {
                            createdAt: -1,
                        }
                    }
                };
                return params;
            });
            const {items: eventMerchants, isPending: isEventMerchantPending} = useFind({
                model: Merchant,
                params: merchantParams
            });

            // Data Table
            const headers = ref([
                {text: root.$t('Username'), value: 'username'},
                {text: root.$t('First Name'), value: 'firstname'},
                {text: root.$t('Last Name'), value: 'lastname'},
                {text: root.$t('Created At'), value: 'createdAt'},
                {text: '', value: 'actions', filterable: false, width: '120', align: 'end'},
            ]);
            
            const deleteMerchant = async () => {
                if (confirm(root.$t('user.confirm_delete'))) {
                    overlay.value = true;
                    let count = 0;
                    let errorCount = 0;
                    let errorMsg = '';
                
                    let i = selectedMerchants.value.length;
                    while (i--) {
                        let temp = await selectedMerchants.value[i].remove().then(() => {
                            selectedMerchants.value.splice(i, 1);
                            return false;
                        }, (e) => {
                            return e.errors ? e.errors.map ? (e.errors.map(a => a.message)).join('; ') : e.message : e.statusText;
                        });
                        count++;
                        if (temp) {
                            errorMsg = '<li>' + temp + '</li>' + errorMsg;
                            errorCount++;
                        }
                    }
                
                    overlay.value = false;
                    if (errorCount) {
                        dialogMsg.value = (count - errorCount) + ' of ' + count + ' Merchant(s) sucessfully deleted.<br><br>' + (errorCount) + ' of ' + count + ' Merchant(s) NOT deleted:<br><ul>' + errorMsg + '</ul>';
                        dialog.value = true;
                    } else {
                        dialogMsg.value = '';
                        root.$store.dispatch('showSnackBar', count + ' Merchant(s) Deleted.' + errorMsg);
                    }
                }
            };

            return {
                selectedMerchants,
                deleteMerchant,
                overlay,
                dialog,
                dialogMsg,

                isEventMerchantPending,
                eventMerchants,

                headers,
                search: ref(''),
                DateTime
            }
        }
    }
</script>
